/**
     * @desc 查询分类列表
用于：browse页、collection创建页，查询出所有分类信息列表
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/category/getCategoryList', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/category/getCategoryList', params);
}
